module.exports = __webpack_public_path__ + "assets/img/energy-icon.c5be852c.png";